import cssVariables from 'tfs.css-variables'

export default {
  container: {
    display: 'flex',
    width: cssVariables.containerWidth,
    margin: '3rem auto',
    justifyContent: 'flex-end',
  },
  topSelection: {
    display: 'flex',
    backgroundColor: cssVariables.colorWhiteHover,
    borderRadius: '.5rem',
    filter: 'drop-shadow(0 0.2rem 3px rgba(0,0,0,0.15))',
  },
  title: {
    marginBottom: '0',
    marginTop: '0',
  },
  selectField: {
    border: 'none',
    color: cssVariables.colorBlue,
    boxShadow: 'none',
    '&> option': {
      color: cssVariables.colorWhiteTypography,
      backgroundColor: cssVariables.colorWhiteHover,
    },
  },
  selectFieldIcon: {
    color: cssVariables.colorBlue,
  },
}
